<template>
    <navBar title="Ares - Finance" :home="true" type="finance"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>
